PJQ.views.settings.PlanRoomGeneralSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Planroom-General')
	},
	events: {
		'keydown .input-default-bid-due-time': function () {
			return false;
		},
		'contextmenu .input-default-bid-due-time': function () {
			return false;
		},
		'click .input-project-user-2-show': 'showUser2Changed'
	},
	beforeFirstRender: function () {
		this.listenTo(this.model, 'fetch', this.render);
	},
	beforeRender: function () {
		this.enableFax = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_FAX) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_FAX) : false;
		this.renderData = {
			model: this.model,
			enableFax: this.enableFax,
			showGroupCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY),
			showGroupContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT),
			showCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY),
			showContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT)
		};
	},
	afterRender: function () {
		this.createDefaultItbMethodArray();

		new PJQ.inputs.Selectpicker({
			el: this.$('.input-default-part-view'),
			defaultValue: (this.model.get('itbDefaultView').length > 0) ? this.model.get('itbDefaultView') : "view_default",
			onChange: _.bind(function (value) {
				this.model.set('itbDefaultView', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Datepicker({
			el: this.$('.input-default-bid-due-time'),
			datepickerOptions: {
				format: 'LT',
				defaultDate: 4
			},
			isTimeOnly: true,
			onChange: _.bind(function () {
				let dateVal = this.$('.input-default-bid-due-time').val(),
					time = dateVal.split(" ")[0],
					amPm = dateVal.split(" ")[1],
					changed = false;
				if (this.model.get('defaultBidDueTime') !== time) {
					this.model.set('defaultBidDueTime', time);
					changed = true;
				}
				if (this.model.get('defaultBidDueTimeAMPM') !== amPm) {
					this.model.set('defaultBidDueTimeAMPM', amPm);
					changed = true;
				}
				if (changed) {
					this.onChange();
				}
			}, this),
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.input-participants-per-page'),
			defaultValue: this.model.get('itbRowsPerPage'),
			onChange: _.bind(function (value) {
				this.model.set('itbRowsPerPage', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.input-default-time-zone'),
			defaultValue: (this.model.get('itbDefaultTimeZone').length > 0) ? this.model.get('itbDefaultTimeZone') : "Central",
			onChange: _.bind(function (value) {
				this.model.set('itbDefaultTimeZone', value);
				this.onChange();
			}, this)
		});

		this.itbPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.input-itb-method'),
			defaultValue: this.defaultArray,
			exclusiveChoices: ["itb-fax", "itb-no-email", "itb-email-fail"],
			isMultiple: true,
			hideDisabled: false,
			onChange: _.bind(function (value) {
				let newValue = [value[0], "itb-email"];
				this.itbPicker.setValue(newValue);
				this.model.set('isITBSendEmail', true);
				if (value.includes('itb-no-email')) {
					this.model.set('isITBSendFaxIfNoEmail', true);
				}
				else {
					this.model.set('isITBSendFaxIfNoEmail', false);
				}
				if (value.includes('itb-email-fail')) {
					this.model.set('isITBSendFaxIfEmailFails', true);
				}
				else {
					this.model.set('isITBSendFaxIfEmailFails', false);
				}
				if (value.includes('itb-fax')) {
					this.model.set('isITBSendFax', true);
				}
				else {
					this.model.set('isITBSendFax', false);
				}

				this.onChange();
			}, this)
		});

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});

		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			watchElements: [
				'input'
			],
			afterChange: _.bind(function () {
				this.onChange();
			}, this)
		});
	},
	createDefaultItbMethodArray: function () {
		this.defaultArray = [];
		if (this.model.get('isITBSendEmail') === true) {
			this.defaultArray.push('itb-email')
		}
		if (this.model.get('isITBSendFaxIfNoEmail') === true) {
			this.defaultArray.push('itb-no-email')
		}
		if (this.model.get('isITBSendFaxIfEmailFails') === true) {
			this.defaultArray.push('itb-email-fail')
		}
		if (this.model.get('isITBSendFax') === true) {
			this.defaultArray.push('itb-fax')
		}
	},
	showUser2Changed: function () {
		if (this.model.get('isShowProjectUser2')) {
			this.$('.project-user-2-outer').removeClass('hidden');
		}
		else {
			this.$('.project-user-2-outer').addClass('hidden');
		}
	},
	onChange: function () {
		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	}
});

PJQ.views.settings.MessageStatuses = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Message-Statuses')
	},
	events: {
		'click .add-message-status': 'addStatusClicked',
		'click .edit-message-status': 'editStatusClicked',
		'click .delete-message-status': 'deleteStatus',
		'click .save-message-status': 'statusSave',
		'click .cancel-edit-message-status': 'cancelEditStatus',
		'keydown .input-message-status': 'disableCommasAndPipes'
	},
	beforeRender: function () {
		this.model = PJQ.app.session.planRoomSettings;
		if (!this.model.isFetched) {
			this.model.fetch({
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}
		this.renderData = {
			model: this.model,
			options: this.options,
			collection: this.collection
		};
	},
	afterRender: function () {
		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});
		if (this.model.messageStatuses) {
			this.dataTable = new PJQ.views.dataTables.DataTable({
				el: this.$(".message-status-table"),
				isHideSearch: true,
				data: this.model.messageStatuses.models,
				rowId: "cid",
				order: [0, 'asc'],
				targets: 'no-sort',
				bSort: false,
				language: {
					zeroRecords: 'Click "Add" to create a new Message Status'
				},
				columns: [
					{
						"data": "attributes.sortOrder",
						"title": "",
						"searchable": false,
						"visible": false
					},
					{
						"data": {
							"display": _.bind(function (row) {
								if (this.messageStatusContext != null && this.messageStatusContext.get('name') === row.get('name') && row.get('name') !== "YES" && row.get('name') !== "NO") {
									return '<input type="text" class="form-control input-message-status wd-250p" value="' + row.get('name') + '">';
								}
								else {
									return row.get('name');
								}
							}, this)
						},
						"title": "Status",
						"width": "25%"
					},
					{
						"data": "",
						"title": "RSVP",
						"width": "25%",
						"orderable": false,
						"searchable": false,
						"render": _.bind(function (data, type, row) {
							let content = row.get('canParticipantSet') === true ? "Yes" : "No";
							if (this.messageStatusContext != null && this.messageStatusContext.get('name') === row.get('name') && this.messageStatusContext.get('sortOrder') === row.get('sortOrder')) {
								content = '<div class="pretty p-switch mr-1 mb-2 mt-2">\n' +
									'                <input type="checkbox" class="input-participant-can-set"\n' +
									'                       />\n' +
									'                <div class="state p-primary">\n' +
									'                    <label><span class="fs-16">RSVP</span></label>\n' +
									'                </div>\n' +
									'            </div>'
							}

							if (this.messageStatusContext != null && this.messageStatusContext.get('canParticipantSet') === true) {
								this.$('.input-participant-can-set').prop('checked', true)
							}
							else {
								this.$('.input-participant-can-set').prop('checked', false)
							}


							return '<div>' + content + '</div>'
						}, this)
					},
					{
						"data": "",
						"title": "",
						"orderable": false,
						"searchable": false,
						"render": _.bind(function (data, type, row) {
							let content = '';
							if (this.messageStatusContext != null && this.messageStatusContext.get('name') === row.get('name') && this.messageStatusContext.get('sortOrder') === row.get('sortOrder')) {
								content = '<button type="button" class="btn btn-success save-message-status wd-30p ml-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger cancel-edit-message-status wd-30p ml-1"><i class="fal fa-times"></i></button>';
							}
							else if (row.get('name') !== "YES" && row.get('name') !== "NO") {
								let disabledAttr = this.messageStatusContext != null ? ' disabled ' : '';
								content = '<button type="button" class="btn btn-info edit-message-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-message-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
							}
							return '<div class="text-align-right show-on-row-hover">' + content + '</div>'
						}, this),
						"width": "80px"
					}
				],
			})
		}
	},
	disableCommasAndPipes: function (e) {
		if (e.keyCode === 188 || e.keyCode === 220) {
			e.preventDefault();
		}
	},
	addStatusClicked: function () {
		this.messageStatusContext = new PJQ.models.settings.PlanRoomSettings({
			name: "",
			canParticipantSet: false,
			sortOrder: this.model.get('messageStatuses').length + 1
		});
		this.dataTable.addRow(this.messageStatusContext);
		this.dataTable.refresh()
	},
	editStatusClicked: function (e) {
		this.messageStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
		this.dataTable.refresh();
	},
	deleteStatus: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row);
		new PJQ.views.modals.DeleteCancel({
			header: "Delete Status",
			body: "Are you sure you want to delete this status?",
			onDelete: _.bind(function () {
				this.dataTable.removeRow(row);
				this.dataTable.refresh;
				this.model.set('messageStatuses', this.dataTable.dataTable.rows().data().toArray());
				this.model.patch(null, {
					success: _.bind(function () {
						this.messageStatusContext = null;
						this.dataTable.refresh();
					}, this)
				});
			}, this)
		});
	},
	messageStatusConstructor: function ({name, canParticipantSet, sortOrder}) {
		this.name = name;
		this.canParticipantSet = canParticipantSet;
		this.sortOrder = sortOrder
	},
	statusSave: function (e) {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
		let $row = $(e.currentTarget).closest('tr'),
			status = this.dataTable.getRow($row).data(),
			$name = $row.find('.input-message-status'),
			isNameValid = _.size($name.val().trim()) > 0;

		if ($name.val().indexOf(',') > -1 || $name.val().indexOf('|') > -1) {
			isNameValid = false;
			this.errorAlert = new PJQ.Alert(this.$('.error'), {
				type: 'danger',
				text: "Password cannot contain commas or pipe characters."
			});
		}
		if (isNameValid) {
			status.set('name', $name.val().trim())
		}
		status.set('canParticipantSet', this.$('.input-participant-can-set').prop('checked'));

		PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
		if (isNameValid) {
			this.model.set('messageStatuses', this.dataTable.dataTable.rows().data().toArray());
			this.model.patch(null, {
				success: _.bind(function () {
					this.messageStatusContext = null;
					this.dataTable.refresh();
				}, this)
			});
		}
	},
	cancelEditStatus: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row);
		if (this.messageStatusContext.name.length === 0) {
			this.dataTable.removeRow(row);
		}
		this.messageStatusContext = null;
		this.dataTable.refresh();
	},
});

// Project status of a Project Contact
PJQ.views.settings.ProjectStatuses = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Project-Statuses')
	},
	events: {
		'click .add-project-status': 'addStatusClicked',
		'click .edit-project-status': 'editStatusClicked',
		'click .delete-project-status': 'deleteStatus',
		'click .save-project-status': 'statusSave',
		'click .cancel-edit-project-status': 'cancelEditStatus',
		'colorpickerChange': 'setBGColor',
		'keyup .colorpicker-input-box': 'setBGColor',
		'keydown .input-project-status': 'disableCommasAndPipes',
		'keydown .input-activity-rank': 'disableNumbers'
	},
	beforeRender: function () {
		this.model = PJQ.app.session.planRoomSettings;
		if (!this.model.isFetched) {
			this.model.fetch({
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}
		this.renderData = {
			model: this.model,
			options: this.options,
			collection: this.collection
		};
	},
	afterRender: function () {
		if (this.model.projectStatuses == null) {
			return;
		}

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});
		let self = this;
		this.filteredData = new PJQ.collections.settings.ProjectStatuses(_.filter(this.model.projectStatuses.models, function (status) {
			let sNameLower = status.get('name').toLowerCase();
			return sNameLower !== "pending" && sNameLower !== "unsent";
		}));
		// this.listenTo(this.model.projectStatuses, 'change', _.bind(this.startReorder, this));
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".project-status-table"),
			isHideSearch: true,
			data: this.filteredData.models,
			rowId: "cid",
			order: [0, 'asc'],
			targets: 'no-sort',
			pageLength: 50,
			bSort: false,
			language: {
				zeroRecords: 'Click "Add" to create a new Project Status'
			},
			sortableOptions: {
				data: this.filteredData,
				stop: _.bind(function (a, b) {
					self.$('tr').filter('.odd, .even').each(function (index, html) {
						let row = $(html).context.id,
							rowData = self.filteredData.get(row);
						rowData.set('sortOrder', index + 1);
					});
					this.startReorder();
				}, this)
			},
			columns: [
				{
					"data": "attributes.sortOrder",
					"title": "",
					"searchable": false,
					"orderable": false,
					"visible": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (row.get('sortOrder') > 2) {
							content = '<div><i class="fas fa-sort"></i></div>'
						}
						return content
					}, this)
				},
				{
					"data": {
						"display": _.bind(function (row) {
							if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && this.projectStatusContext.get('sortOrder') === row.get('sortOrder') && row.get('name') !== "PENDING" && row.get('name') !== "UNSENT" && row.get('name') !== "DOWNLOADED" && row.get('name') !== "VIEWED") {
								return '<input type="text" class="form-control input-project-status wd-200p" value="' + row.get('name') + '">';
							}
							else {
								return '<span style="color:' + row.get('backgroundColor') + ';">' + row.get('name') + '</span>';
							}
						}, this)
					},
					"title": "Status",
					"width": "200px"
				},
				{
					"data": "",
					"title": "RSVP",
					"width": "50px",
					"orderable": false,
					"searchable": false,
					"render": _.bind(function (data, type, row) {
						let content = row.get('canParticipantSet') === true ? "Yes" : "No";
						if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && this.projectStatusContext.get('sortOrder') === row.get('sortOrder') && row.get('name') !== "PENDING" && row.get('name') !== "UNSENT" && row.get('name') !== "DOWNLOADED" && row.get('name') !== "VIEWED") {
							content = '<div class="pretty p-switch mr-1 wd-50p mr-2 ml-2">\n' +
								'                <input type="checkbox" class="input-participant-can-set"\n' +
								'                       />\n' +
								'                <div class="state p-primary">\n' +
								'                    <label><span class="fs-16">RSVP</span></label>\n' +
								'                </div>\n' +
								'            </div>'
						}
						if (this.projectStatusContext != null && this.projectStatusContext.get('canParticipantSet') === true) {
							this.$('.input-participant-can-set').prop('checked', true)
						}
						else {
							this.$('.input-participant-can-set').prop('checked', false)
						}

						return '<div>' + content + '</div>'
					}, this)
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "200px",
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && row.get('name') !== "DOWNLOADED" && row.get('name') !== "VIEWED") {
							return '<div class="input-group project-status-color-input wd-200p"><input type="text" class="form-control colorpicker-input-box"/><span class="input-group-append"><div class="input-group color-picker"><span class="input-group-text colorpicker-input-addon"><i></i></span></div></span></div>'
						}
						return '<div>' + content + '</div>'
					}, this)
				},
				{
					"data": {
						"display": _.bind(function (row) {
							if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && this.projectStatusContext.get('sortOrder') === row.get('sortOrder') && row.get('name') !== "PENDING" && row.get('name') !== "UNSENT") {
								return '<input type="text" class="form-control input-activity-rank wd-100p" value="' + row.get('activityRank') + '">';
							}
							else {
								return '<span>' + row.get('activityRank') + '</span>';
							}
						}, this)
					},
					"title": "Activity Score",
					"width": "100px"
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name')) {
							content = '<button type="button" class="btn btn-success save-project-status wd-30p ml-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger cancel-edit-project-status wd-30p ml-1"><i class="fal fa-times"></i></button>';
						}
						else {
							if (row.get('name') === "UNSENT" || row.get('name') === "PENDING" || row.get('name') === "VIEWED" || row.get('name') === "DOWNLOADED" || row.get('sortOrder') === 1 || row.get('sortOrder') === 2) {
								let disabledAttr = this.projectStatusContext != null ? ' disabled ' : '';
								content = '<button type="button" class="btn btn-info edit-project-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button>'
							}
							else {
								let disabledAttr = this.projectStatusContext != null ? ' disabled ' : '';
								content = '<button type="button" class="btn btn-info edit-project-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-project-status wd-30p ml-1"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
							}
						}
						return '<div class="text-align-right show-on-row-hover">' + content + '</div>'
					}, this),
					"width": "80px",
				}
			],
		});
	},
	disableCommasAndPipes: function (e) {
		if (e.keyCode === 188 || e.keyCode === 220) {
			e.preventDefault();
		}
	},
	disableNumbers: function (e) {
		PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
	},
	addStatusClicked: function () {
		this.projectStatusContext = new PJQ.models.settings.PlanRoomSettings({
			name: "",
			backgroundColor: "#000000",
			foregroundColor: "#000000",
			canParticipantSet: false,
			activityRank: 0,
			sortOrder: this.model.get('projectStatuses').length + 1,
		});
		this.dataTable.addRow(this.projectStatusContext);
		this.editStatus();
	},
	editStatusClicked: function (e) {
		this.projectStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
		this.editStatus();
	},
	editStatus: function (e) {
		this.dataTable.refresh();
		this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
			format: 'hex',
			color: this.projectStatusContext.get('backgroundColor'),
			autoInputFallback: false
		});
		this.$('.colorpicker-input-box').val(this.projectStatusContext.get('backgroundColor'));
		this.$('.input-project-status').css('color', this.projectStatusContext.get('backgroundColor'));
	},
	setBGColor: function (e) {
		if (e.type === 'keyup') {
			if (e.keyCode === 13) {
				$(e.currentTarget).blur()
			}
			let color = this.$('.colorpicker-input-box').val();
			if (color.split('')[0] === '#' && color.trim().length === 7) {
				this.colorPicker.setColor(color);
				this.projectStatusContext.set('backgroundColor', color.toUpperCase());
				this.$('.input-project-status').css('color', color.toUpperCase());
				PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
			}
		}

		else {
			let color = this.colorPicker.getColor();
			if (color.split('')[0] === '#' && color.trim().length === 7) {
				this.$('.colorpicker-input-box').val(color);
				this.projectStatusContext.set('backgroundColor', color);
				this.$('.input-project-status').css('color', color);
				PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
			}
		}
	},
	startReorder: function () {
		let newArray = [];
		_.each(this.dataTable.dataTable.rows().data().toArray(), function (status) {
			newArray[status.attributes.sortOrder - 1] = status;
		});
		this.saveReorder(newArray)
	},
	saveReorder: function (array) {
		let isNull = false;
		if (array.length !== this.dataTable.dataTable.rows().data().toArray().length) {
			isNull = true;
		}

		_.each(array, function (node, index) {
			if (node !== undefined) {
				// Don't allow Accept or Decline to be reordered
				if (index === 0) {
					if (node.get('name') !== 'ACCEPT') {
						isNull = true;
					}
				}
				else if (index === 1) {
					if (node.get('name') !== 'DECLINE') {
						isNull = true;
					}
				}
			}
			else {
				isNull = true
			}
		});
		if (!isNull && this.projectStatusContext == null) {
			this.loader = new PJQ.Loader(this.$('.project-status-table'));
			this.model.set('projectStatuses', array);
			this.model.patch(null, {
				success: _.bind(function () {
					if (this.loader) {
						this.loader.remove();
					}
					this.render();
				}, this)
			});
		}
		else {
			this.dataTable.render()
		}
	},
	deleteStatus: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row),
			status = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Delete Status",
			body: "Are you sure you want to delete this status?",
			onDelete: _.bind(function () {
				this.dataTable.removeRow(row);
				this.dataTable.refresh;
				this.model.set('projectStatuses', this.dataTable.dataTable.rows().data().toArray());
				this.model.patch(null, {
					success: _.bind(function () {
						this.projectStatusContext = null;
						this.dataTable.refresh();
					}, this)
				});
			}, this)
		});
	},
	projectStatusConstructor: function ({name, canParticipantSet, color, sortOrder}) {
		this.name = name;
		this.color = color;
		this.canParticipantSet = canParticipantSet;
		this.sortOrder = sortOrder
	},
	statusSave: function (e) {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
		let $row = $(e.currentTarget).closest('tr'),
			status = this.dataTable.getRow($row).data(),
			$name = $row.find('.input-project-status'),
			name = $row.find('.input-project-status').length > 0 ? $row.find('.input-project-status').val() : status.get('name'),
			$rank = $row.find('.input-activity-rank'),
			isNameValid = _.size(name.trim()) > 0,
			isRankValid = _.size($rank.val().trim()) > 0 && !isNaN(parseInt($rank.val().trim()));

		let color = '#555',
			isColorValid;
		if (name.toLowerCase() !== "downloaded" && name.toLowerCase() !== "viewed") {
			color = this.$('.colorpicker-input-box').val();
			isColorValid = color.split('')[0] === '#' && color.trim().length === 7;
		}
		else {
			isColorValid = true;
		}

		if (name.indexOf(',') > -1 || name.indexOf('|') > -1) {
			isNameValid = false;
			this.errorAlert = new PJQ.Alert(this.$('.error'), {
				type: 'danger',
				text: "Name cannot contain commas or pipe characters."
			});
		}
		if (isNameValid) {
			status.set('name', name);
		}
		if (isRankValid) {
			status.set('activityRank', parseInt($rank.val().trim()));
		}
		status.set('canParticipantSet', (this.$('.input-participant-can-set').prop('checked')));
		status.set('foregroundColor', PJQ.helpers.colorHelpers.idealLinkColorForBackground(color));


		PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), isColorValid, {
			errorText: isColorValid ? "" : "Hex must begin with a # followed by 6 letters and/or numbers!"
		});
		PJQ.helpers.inputHelpers.setInputError($rank, isRankValid, {
			errorText: isRankValid ? "" : "Rank can not be empty and must be a number!"
		});

		if (isNameValid && isColorValid && isRankValid) {
			this.model.set('projectStatuses', this.dataTable.dataTable.rows().data().toArray());
			this.model.patch(null, {
				success: _.bind(function () {
					this.projectStatusContext = null;
					this.render()
				}, this)
			});
		}
	},
	cancelEditStatus: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row);
		if (this.projectStatusContext.get('name').length === 0) {
			this.dataTable.removeRow(row);
		}
		this.projectStatusContext = null;
		this.dataTable.refresh();
	},
});

// ProjectStatusId of a Project
PJQ.views.settings.ProjectStatusList = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Project-Status-List')
	},
	events: {
		'click .add-project-status': 'addClicked',
		'click .btn-edit-project-status': 'editProjectStatusClicked',
		'click .btn-delete-project-status': 'deleteProjectStatusClicked',
		'click .btn-save-project-status': 'projectStatusSave',
		'click .btn-cancel-edit-project-status': 'cancelEditProjectStatus'
	},
	beforeFirstRender: function () {

	},
	afterRender: function () {
		this.collection = PJQ.app.session.projectStatuses;
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".project-status-list-table"),
			isHideSearch: true,
			data: PJQ.app.session.projectStatuses.models,
			rowId: "cid",
			targets: 'no-sort',
			order: [2, 'asc'],
			language: {
				zeroRecords: 'Click "Add" to create a new Project Status'
			},
			bSort: false,
			sortableOptions: {
				data: PJQ.app.session.projectStatuses,
			},
			rowCallback: function (row, data, index) {
				$(row).find('td:eq(0)').css('color', '#'+data.get('color'));
			},
			contextMenuOptions: {
				actions: [
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function (row) {
							return row.data().get('masterUserId') !== -1;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteProjectStatus(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": {
						"display": _.bind(function (row) {
							if (this.projectStatusContext != null && this.projectStatusContext.id === row.id) {
								return '<input type="text" class="form-control input-project-status-name" value="' + row.get('name') + '">';
							} else {
								return row.get('name');
							}
						}, this)
					},
					"title": "Status",
					"orderable": false
				},
				{
					"data": "",
					"title": "",
					"width": this.projectStatusContext != null ? "200px" : '0px',
					"orderable": false,
					"searchable": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (this.projectStatusContext != null && this.projectStatusContext.id === row.id) {
							content = '<div class="input-group project-status-color-input wd-200p"><input type="text" class="form-control"/><span class="input-group-append"><span class="input-group-text colorpicker-input-addon"><i></i></span></span></div>'
						}
						return '<div class="text-align-right">' + content + '</div>'
					}, this)
				},
				{
					"data": "attributes.sortOrder",
					"title": "",
					"searchable": false,
					"visible": false
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": '120px',
					"render": _.bind(function (data, type, row) {
						let buttons = '';
						if (this.projectStatusContext != null && this.projectStatusContext.id === row.id) {
							buttons = '<button type="button" class="btn btn-success btn-save-project-status wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-project-status wd-30p"><i class="fal fa-times"></i></button>';
						} else {
							buttons += '<button type="button" class="btn btn-info btn-edit-project-status wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
							if (row.get('masterUserId') !== -1) {
								buttons += '<button type="button" class="btn btn-danger btn-delete-project-status wd-30p"><i class="fal fa-trash"></i></button>';
							}
						}
						return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>'
					}, this)
				},
			],
		});
	},
	editProjectStatusClicked: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row),
			projectStatus = row.data(),
			fnEdit = _.bind(function (eps) {
			this.projectStatusContext = eps;
			this.defaultColor = '#' + eps.get('color');
			this.dataTable.refresh();
			new PJQ.colors.ColorPicker(this.$('.project-status-color-input'), {
				format: 'hex',
				color: '#' + eps.get('color'),
				onChange: _.bind(function (value) {
					this.projectStatusContext.set('color', value.substring(1));
					this.$('.input-project-status-name').css('color', value);
				}, this)
			});
			this.$('.input-project-status-name').css('color', '#'+eps.get('color'));
		}, this);
		if (projectStatus.get('masterUserId') === -1) {
			this.changeDefaultAlert(projectStatus, function (projectStatuses, newProjectStatus) {
				fnEdit(newProjectStatus);
			});
		} else {
			fnEdit(projectStatus);
		}

	},
	changeDefaultAlert(returnCopy, callback) {
		this.dataTable.refresh();
		new PJQ.views.modals.YesNo({
			header: "Change Project Statuses?",
			body: 'You are currently using the system default project statuses.  To edit a project status, we will need to create custom project statuses for your company.  This may take a minute, would you like to continue?',
			onYes: _.bind(function () {
				this.copyProjectStatuses(returnCopy, _.bind(function (projectStatuses, newProjectStatus) {
					this.dataTable.resetData(PJQ.app.session.projectStatuses.models);
					callback(projectStatuses, newProjectStatus);
				}, this));
			}, this)
		});
	},
	copyProjectStatuses: function (returnCopy, callback) {
		this.collection.copy(_.bind(function () {
			let newPs = null;
			if (returnCopy != null) {
				let returnName = returnCopy.get('name');
				newPs = _.find(this.collection.models, function (u) {
					return u.get('name') === returnName;
				});
			}
			callback(this.collection.models, newPs);
		}, this));
	},
	addClicked: function () {
		let fnAdd = _.bind(function () {
			let newProjectStatus = new PJQ.models.projectStatuses.ProjectStatus({
				name: "",
				color: '000000',
				sortOrder: this.collection.length + 1,
				isDefault: this.collection.length === 0
			});
			this.collection.add(newProjectStatus);
			this.dataTable.addRow(newProjectStatus);
			this.projectStatusContext = newProjectStatus;
			this.defaultColor = this.projectStatusContext.get('color');
			this.projectStatusColor = this.projectStatusContext.attributes.color;
			this.dataTable.refresh();
			new PJQ.colors.ColorPicker(this.$('.project-status-color-input'), {
				format: 'hex',
				color: '#' + this.projectStatusColor,
				onChange: _.bind(function (value) {
					this.projectStatusContext.set('color', value.substring(1));
					this.$('.input-project-status-name').css('color', value);
				}, this)
			});
			this.$('.input-user-type-name').css('color', this.projectStatusContext.get('color'));
		}, this);
		if (this.collection.length > 0 && this.collection.models[0].get('masterUserId') === -1) {
			this.changeDefaultAlert(null, function () {
				fnAdd();
			});
		} else {
			fnAdd();
		}
	},
	projectStatusSave: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			projectStatus = this.dataTable.getRow($row).data(),
			$name = $row.find('.input-project-status-name');

		let isNameValid = _.size($name.val()) > 0;
		PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

		if (!isNameValid)
			return;
``
		projectStatus.set('name', $name.val());
		projectStatus.set('sortOrder', projectStatus.attributes.sortOrder);

		projectStatus.save(null, {
			success: _.bind(function () {
				this.projectStatusContext = null;
				this.dataTable.refresh();
			}, this)
		});
	},
	deleteProjectStatusClicked(e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row);

		this.deleteProjectStatus(row);
	},
	deleteProjectStatus: function(row) {
		let projectStatus = row.data(),
			fnDelete = _.bind(function (dps) {
				new PJQ.views.modals.DeleteCancel({
					header: "Delete Project Status",
					body: "Are you sure you want to delete this Project Status?  Any Project that currently has this Status will be set to the Default Status.",
					onDelete: _.bind(function () {
						projectStatus.destroy({
							success: _.bind(function () {
								this.collection.remove(dps);
								this.dataTable.removeRow(row);
								this.dataTable.refresh();
							}, this)
						});
					}, this)
				});
			}, this);
		if (projectStatus.get('masterUserId') === -1) {
			this.changeDefaultAlert(projectStatus, function (projectStatuses, newProjectStatus) {
				fnDelete(newProjectStatus);
			});
		} else {
			fnDelete(projectStatus);
		}

	},
	cancelEditProjectStatus: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row),
			status = row.data();
		status.set('color', this.defaultColor);
		this.projectStatusContext = null;
		this.projectStatusColor = null;
		if (status.get('name').length === 0) {
			this.dataTable.removeRow(row);
		}
		this.dataTable.refresh();
	},
});


PJQ.views.settings.ProjectNDAs = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'project-ndas')
	},
	events: {
		'click .btn-add-nda': 'addNDAClicked',
		'click .btn-edit-nda': 'editNDAClicked',
		'click .btn-delete-nda': 'deleteNDAClicked'
	},
	beforeFirstRender: function () {
		PJQ.app.session.fetchNDAs(_.bind(function (ndas) {
			this.collection = ndas;
			this.render();
		}, this));
	},
	afterRender: function () {
		if (this.collection == null) {
			return;
		}

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".project-ndas"),
			isHideSearch: true,
			data: this.collection.models,
			rowId: "cid",
			order: [0, 'asc'],
			language: {
				zeroRecords: 'Click "Add" to create a new Project NDA'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editNDA(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editNDA(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteNDA(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attributes.isDefault",
					"title": "",
					"width": "40px",
					"render": _.bind(function (data) {
						if (data) {
							return '<i class="fad fa-crown text-gold"></i>';
						}
						return '';
					}, this)
				},
				{
					"data": "attributes.name",
					"title": "Name",
					// "render": _.bind(function (data, type, row) {
					//
					// }, this)
				},
				{
					"data": "",
					"title": "",
					"width": "80px",
					"render": _.bind(function (data, type, row) {
						return '<div class="show-on-row-hover"><button type="button" data-punchlist-id="' + data + '" class="btn btn-info btn-edit-nda"><i class="fal fa-pencil"></i></button><button type="button" data-punchlist-id="' + data + '" class="btn btn-danger btn-delete-nda ml-1"><i class="fal fa-trash"></i></button></div>';
					}, this)
				}
			],
		});
	},
	addNDAClicked: function () {
		let newNda = new PJQ.models.projects.ProjectNDA();
		if (_.size(this.collection.models) === 0) {
			newNda.set('isDefault', true);
		}
		this.editNDA(newNda);
	},
	editNDAClicked: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row),
			nda = row.data();
		this.editNDA(nda);
	},
	editNDA: function (nda) {
		let isNew = nda.isNew();
		new PJQ.views.projects.EditProjectNDAModal({
			model: nda,
			onSave: _.bind(function () {
				if (isNew) {
					this.collection.add(nda);
					this.dataTable.addRow(nda);
				}
				this.dataTable.refresh();
			}, this),
			onDelete: _.bind(function (nda) {
				if (nda.id > 0) {
					let row = this.dataTable.getRow(nda.cid);
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteNDAClicked: function (e) {
		let $row = $(e.currentTarget).closest('tr'),
			row = this.dataTable.getRow($row);
		this.deleteNDA(row);
	},
	deleteNDA: function (row) {
		let nda = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Delete NDA",
			body: "Are you sure you want to delete this project NDA?",
			onDelete: _.bind(function () {
				this.dataTable.removeRow(row);
				this.dataTable.refresh;
				this.collection.remove(nda);
				nda.destroy();
			}, this)
		});
	}
});
